import { styled } from 'styled-components'
import { motion } from 'motion/react'
import { SlSocialInstagram } from 'react-icons/sl'
import { CiMail } from 'react-icons/ci'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.9rem;
`

export const StyledLink = styled(motion.a)`
  margin-top: 0.35rem;
  color: ${({ theme }) => theme.colors.palette.secondary};
  text-decoration: none;
`

export const StyledLogoContainer = styled(motion.div)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2.2rem;
`

export const StyledLogoWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledLogoInstagram = styled(SlSocialInstagram)`
  color: ${({ theme }) => theme.colors.palette.secondary};
  margin-left: 0.45rem;
`

export const StyledLogoMail = styled(CiMail)`
  color: ${({ theme }) => theme.colors.palette.secondary};
`
